import styled from 'react-emotion';
import { IFlexProps } from './Column';

interface IRowProps {
  align?: IFlexProps['align'];
  justify?: IFlexProps['justify'];
  my?: string;
}

const Row = styled('div')`
  display: flex;
  align-items: center;
  ${(props: IRowProps) =>
    props.justify && `justify-content: ${props.justify};`} ${props =>
    props.my && `margin-top: ${props.my}; margin-bottom: ${props.my};`};
`;

export default Row;



// WEBPACK FOOTER //
// ./src/components/Row.ts